<script lang="ts">
import { defineComponent } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCreditCard, faUsers, faHandshake } from '@fortawesome/free-solid-svg-icons'

interface NavItem {
    path: string
    label: string
    icon: any
}

export default defineComponent({
    name: 'SideBar',

    components: { FontAwesomeIcon },

    props: {
        isOpen: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            navItems: [
                { path: '/', label: 'Welcome', icon: faHandshake },
                { path: '/payments', label: 'Payments', icon: faCreditCard },
                { path: '/users', label: 'Users', icon: faUsers }
            ] as NavItem[]
        }
    },

    emits: ['close'],

    computed: {
        faCreditCard() {
            return faCreditCard;
        },
        faUsers() {
            return faUsers;
        },
        faHandshake() {
            return faHandshake;
        },
    },

    methods: {
        linkClass(path: string): string[] {
            const current = this.$route.path
            const active =
                path === '/'
                    ? current === '/'
                    : current.startsWith(path)

            return [
                'group flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-all duration-200',
                active
                    ? 'bg-indigo-600 text-white shadow-md shadow-indigo-200'
                    : 'text-gray-600 hover:bg-white hover:text-gray-900 hover:shadow-sm'
            ]
        }
    }

})
</script>

<template>
    <aside
        class="fixed md:static inset-y-0 left-0 z-50 w-72 bg-white/80 backdrop-blur-xl border-r border-gray-200/60 px-5 py-6 flex flex-col gap-8 transform transition-transform duration-300 ease-out"
        :class="[
            isOpen ? 'translate-x-0' : '-translate-x-full',
            'md:translate-x-0'
        ]">

        <RouterLink to="/">
            <div class="flex items-center gap-3 cursor-pointer group">
                <div
                    class="h-11 w-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center text-xl font-bold shadow-md group-hover:scale-105 transition">
                    ₹
                </div>
                <span class="text-xl font-extrabold tracking-tight text-gray-900">
                    Pay<span class="text-indigo-600">Log</span>
                </span>
            </div>
        </RouterLink>

        <nav class="flex flex-col gap-2">
            <RouterLink v-for="item in navItems" :key="item.path" :to="item.path" :class="linkClass(item.path)"
                @click="$emit('close')" class="md:pointer-events-auto">
                <FontAwesomeIcon :icon="item.icon" class="text-base" />
                <span>{{ item.label }}</span>
            </RouterLink>
        </nav>

        <div class="mt-auto text-xs text-gray-400 tracking-wide">
            PayLog • v1.0.0
        </div>
    </aside>

    <!-- Mobile backdrop -->
    <div v-if="isOpen" class="fixed inset-0 z-40 bg-black/10 backdrop-blur-sm md:hidden transition-opacity"
        @click="$emit('close')" />
</template>
